
import { useRoute } from 'vue-router'
import { ref, onBeforeMount } from 'vue'
import { getOfficialEnjoySongInfo, getPersonalEnjoySongInfo } from '@/services/songs'
import config from '@/config'
import { songType, songSheetType } from '@/utils/dataMap/song'
import UploadSongConfig from './enjoy-song-form/UploadSongConfig'

export default {
  name: 'Detail',
  components: {
    UploadSongConfig
  },
  setup () {
    const route = useRoute()
    const formState = ref({
      tags: []
    })
    onBeforeMount(async () => {
      const getInfo = route.params.type === '1' ? getOfficialEnjoySongInfo : getPersonalEnjoySongInfo
      formState.value = await getInfo(route.params.id)
    })

    return {
      history,
      formState,
      config,
      songType,
      songSheetType
    }
  }
}
